import React from 'react'
import PropTypes from 'prop-types'

export default function SystemButton(props) {
  return (
    <div>
      <button
        type="button"
        className="btn btn-outline-primary btn-block"
        data-toggle="tooltip"
        data-placement="top"
        title={props.info}
        onClick={() =>
          props.sysName === 'Apple (Mac)'
            ? props.setIsOpen({
                appleOpen: !props.isOpen,
                winOpen: false,
              })
            : props.setIsOpen({
                appleOpen: false,
                winOpen: !props.isOpen,
              })
        }
      >
        <h3>{props.sysName}</h3>
      </button>
    </div>
  )
}

SystemButton.propTypes = {
  sysName: PropTypes.string,
  info: PropTypes.string,
  isOpen: PropTypes.bool,
  isOpenAll: PropTypes.object,
  setIsOpen: PropTypes.func,
}
